export default {
  categoriesList: [],
  fetchTagsError: '',
  tagsList: [],
  subTagsList: [],
  isSavingCategoriesInProgress: false,
  isSavingTagInProgress: false,
  isDeletingTagInProgress: false,
  categoryViews: [],
  isUploadingTags: false,
  uploadedTags: [],
  isImportingTags: false,
};
